import React, { useState, useEffect } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { useForm, Controller } from "react-hook-form";
import masterApi from "../../../services/masterApi";
import apiService from "../../../services/apiService";  // Import from services folder
import { toast } from 'react-toastify';
import Select from "react-select";
import { ThreeDotLoader } from "../../../components/Loader/Loader"; // Add this import
import { RecordStatusEnum } from "../../../enum/enum";


export const AddUser = ({ closePopup,existingdata, isViewMode, isEditMode }) => {
  const searchTextLimit = process.env.REACT_APP_CONFIDENTIAL_SEARCH_TEXT_LIMIT;
  const { control, register, handleSubmit, reset, formState: { errors } ,setValue } = useForm();
  const [userLst, setUserLst] = useState([]);
  const [departmentLst, setDepartmentLst] = useState([]);
  const [designationLst, setDesignationLst] = useState([]);
  const [roleLst, setRoleLst] = useState([]);
  const [selectedUser, setSelectedUser] = useState({});
  const [searchedUsers, setSerarchedUsers] = useState([])
  const [isLoading, setIsLoading] = useState(false); // Loader state


  useEffect(() => {
    console.log("Validation Errors:", errors);
}, [errors]);

  const addDepartmentDetails = async (departments) => {  
    try {      
      const payload = {
            departments: [{
              DepartmentId: departments.DepartmentId,
              DepartmentTitle: departments.DepartmentTitle,
            }]
    }; 
      const response = await masterApi.createDepartmentFromApi(JSON.stringify(payload)); 
      return response;
    } catch (error) {
      console.error("Error adding Department details:", error);
      throw error;
    }
  };
  const addDesignationDetails = async (designations) => {  
    try {      
      const payload = {
            designations: [{
              DesignationId: designations.DesignationId,
              DesignationTitle: designations.DesignationTitle,
            }]
    }; 
      const response = await masterApi.createDesignationFromApi(JSON.stringify(payload)); 
      return response;
    } catch (error) {
      console.error("Error adding Designation details:", error);
      throw error;
    }
  };


  const onSubmit = async (data) => { 
    setIsLoading(true); // Start loader
    try {
      // ...existing code...
      const selectedDepartmentDetails = departmentLst.find(department => department.DepartmentId === String(data.department));
      try {
        const departmentResponse = await addDepartmentDetails(selectedDepartmentDetails);
        if (!departmentResponse?.ok) {
          console.warn("Failed to add department details");
        }
      } catch (error) {
        if (error.message.includes("ID must be unique")) {
          console.warn("Duplicate department ID, continuing execution");
        } else {
          throw error; // Re-throw other errors
        }
      }
      // Add the selected designation details first
      const selectedDesignationDetails = designationLst.find(designation => designation.DesignationId === String(data.designation));
      try {
        const designationResponse = await addDesignationDetails(selectedDesignationDetails);
        if (!designationResponse?.ok) {
          console.warn("Failed to add designation details");
        }
      } catch (error) {
        if (error.message.includes("ID must be unique")) {
          console.warn("Duplicate designation ID, continuing execution");
        } else {
          throw error; // Re-throw other errors
        }
      }
      if(existingdata) {
        data.id = existingdata;
        const response = await masterApi.editUser(data);
        if(response?.ok){
          toast.success(response?.message, {
            position: "top-right",
            autoClose: 2000,
          });
          closePopup();
        } else {
          toast.error(response?.response?.data?.message, {
            position: "top-right",
            autoClose: 2000,
          });
        }
      } else {  
        data.id = data.userId.id;
        const response = await masterApi.createUser(data);
        if(response?.data?.ok){
          toast.success(response?.data?.message, {
            position: "top-right",
            autoClose: 2000,
          });
          closePopup();
        } else {
          alert(response?.response?.data?.error);
        }
      }
    } finally {
      setIsLoading(false); // Stop loader
    }
  };
  
  const loadMasterData = async () => {  
    setIsLoading(true); // Start loader
    try {
      // ...existing code...
      let response = await apiService.getActiveUsers();
      const userformattedData = response?.map((user) => ({
        UserId: user.UserId,
        FirstName: user.FirstName,
        LastName: user.LastName,
        MobileNo: user.MobileNo,
        Email: user.Email,
        OfficialEmail: user.OfficialEmail,
        ProfileImageFolder: user.ProfileImageFolder,
        ProfileImageName: user.ProfileImageName,
        DesignationTitle: user.DesignationTitle,
        DepartmentId: user.DepartmentId
      }));
      setUserLst(userformattedData); 

      response = await apiService.getActiveDepartments();
      const departmentformattedData = response?.map((department) => ({
        DepartmentId: department.DepartmentId,
        DepartmentTitle: department.DepartmentTitle,
      }));
      setDepartmentLst(departmentformattedData); 

      response = await apiService.getActiveDesignations();  
      const designationformattedData = response?.map((designation) => ({
        DesignationId: designation.DesignationId,
        DesignationTitle: designation.DesignationTitle,
      }));
      setDesignationLst(designationformattedData); 

      response = await masterApi.getActiveRoles();
      if (response?.data?.roles && Array.isArray(response.data.roles)) {
        setRoleLst(response.data.roles);
      } else {
        setRoleLst([]);
      }
      if(existingdata){ 
        let response = await masterApi.getUserById(existingdata);  
        if(response?.data?.ok){
          const data = response?.data?.user
          reset({
            firstName: data.firstName,
            lastName: data.lastName,
            designation: data.designationId,
            department: data.departmentId,
            role: data.roleId,
            notes: data.notes,
            email: data.email,
            mobile: data.mobile,
            recordStatus: data.recordStatus
          })
        }
      }
    } finally {
      setIsLoading(false); // Stop loader
    }
  }

  useEffect( () => {
    loadMasterData();    
  }, []);  

  const handleUserChange = (event) => {  
    // const userId = event.target.value;
    if(event){
      const userId = event.id;
      const user = userLst.find((user) => user.UserId === userId); 
      setSelectedUser(user);
    }else{
      setSelectedUser({})
    }
  };

  const isUserSelected = !!selectedUser.UserId;

  useEffect(() => {
      setValue("firstName", selectedUser?.FirstName || ""); 
      setValue("lastName", selectedUser?.LastName || ""); 
      setValue("email", selectedUser?.Email || ""); 
      setValue("mobile", selectedUser.MobileNo || "");
      setValue("department", selectedUser?.DepartmentId || ""); // Auto-set department
      setValue("designation", 
      designationLst.find(d => d.DesignationTitle === selectedUser?.DesignationTitle)?.DesignationId || ""
    );
     
  }, [selectedUser, setValue]);

  const filterUsers = (filterStr) => {
    if(filterStr.length >= searchTextLimit){
      const matchedUsers = userLst
        .filter(user => user.FirstName.toLowerCase().startsWith(filterStr.toLowerCase()))
        .map(user => ({
          label: `${user.FirstName} ${user.LastName}`,
          id: user.UserId
        }));
      setSerarchedUsers(matchedUsers)
    }else{
      setSerarchedUsers([])
    }
    }
  

  return (
    <div className="popup-container xrta-small-popup">
      {isLoading && <ThreeDotLoader />}
      <div className="shadeClose" onClick={closePopup}></div>
      <div className="popup-inner">
        <div className="inner-design">
          <div className="popup-header d-flex align-items-center gap2">
            <h2>{isViewMode ? "User Details" : isEditMode ? "Edit User Details" : "Add User"}</h2>
            <button type="button" className="ms-auto close-btn" onClick={closePopup}>
              <IoCloseOutline />
            </button>
          </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="popup-content">
              <div className="row">
              {(!isEditMode && !isViewMode) && (
                <div className="col-12 col-md-12 mb-4">
                  <label className="form-label">
                    Select User <span className="asterisk danger"></span>
                  </label>
                  
                    <Controller
                      name="userId"
                      control={control}
                      defaultValue={null}
                      rules={{ required: "user is required" }}
                      render={({ field }) => (
                        <Select
                        {...field}
                        options={searchedUsers}
                        classNamePrefix="react-select"
                        placeholder="Select User"
                        // value={searchedUsers.find(option => option.id === field.value) || null}
                        value={field?.value}
                        onChange={(selectedOption) => {
                          handleUserChange(selectedOption);
                          field.onChange(selectedOption || null); // Store only the id
                        }}
                        onInputChange={(input, action) => filterUsers(input)}
                        isClearable
                        />
                      )}
                  />
                  
                </div>
              )}

                <div className="col-12 col-md-6 mb-4">
                  <label className="form-label">
                    First Name <span className="asterisk danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.firstName ? "is-invalid" : ""}`}
                    id="jobTitle1"
                    {...register("firstName", { required: "First Name is required" })}
                    readOnly={isEditMode  || isViewMode || isUserSelected}
                  />
                </div>
                <div className="col-12 col-md-6 mb-4">
                  <label className="form-label">
                    Last Name <span className="asterisk danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.lastName ? "is-invalid" : ""}`}
                    id="jobTitle2"
                    {...register("lastName", { required: "Last Name is required" })}
                    readOnly={isEditMode  || isViewMode || isUserSelected}
                  />
                </div>
                <div className="col-12 col-md-12 mb-4">
                  <label className="form-label">
                    Designation <span className="asterisk danger">*</span>
                  </label>
                  <select className={`form-select ${errors.designation ? "is-invalid" : ""}`}  {...register("designation", { required: true })}
                
                  onChange={(e) => {
                    const selectedDesignation = designationLst.find(d => d.DesignationId == e.target.value);
                    setSelectedUser({
                      ...selectedUser,
                      DesignationTitle: selectedDesignation?.DesignationTitle || '',
                    });
                  }}
                  disabled={isEditMode  || isViewMode || isUserSelected}
     >
                    <option value="">Select</option>
                    {
                      designationLst?.map((designation) => (
                        <option key={designation.DesignationId} value={designation.DesignationId}>
                          {designation.DesignationTitle}
                        </option>
                      ))
                    }
                    {/* {
                      designationLst?.map((department) => (
                        <option key={department.id} value={department.id}>
                          {department.title}
                        </option>
                      ))
                    } */}
                  </select>
                </div>
                <div className="col-12 col-md-12 mb-4">
                  <label className="form-label">
                    Department <span className="asterisk danger">*</span>
                  </label>
                  <select className={`form-select ${errors.department ? "is-invalid" : ""}`}  {...register("department", { required: true })}
                 
                  disabled={isEditMode  || isViewMode || isUserSelected}
    >
                    <option value="">Select</option>
                    {
                      departmentLst?.map((department) => (
                        <option key={department.DepartmentId} value={department.DepartmentId}>
                          {department.DepartmentTitle}
                        </option>
                      ))
                    }
                    {/* {
                      departmentLst?.map((department) => (
                        <option key={department.id} value={department.id}>
                          {department.title}
                        </option>
                      ))
                    } */}
                  </select>
                </div>
                {/* <div className="col-12 col-md-12 mb-4">
                  <label className="form-label">
                    Mobile No. <span className="asterisk danger">*</span>
                  </label>
                  <input
                    type="number"
                    placeholder="Enter the phone number"
                    className={`form-control ${errors.mobile ? "is-invalid" : ""}`}
                    {...register("mobile", { required: true})}
                    readOnly={isUserSelected}

                  />
                </div> */}
                <div className="col-12 col-md-12 mb-4">
                  <label className="form-label">
                    Email <span className="asterisk danger">*</span>
                  </label>
                  <input
                    type="email"
                    placeholder="Enter the email id"
                    className={`form-control ${errors.email ? "is-invalid" : ""}`}
                    {...register("email", { required: true })}
                    readOnly={isEditMode  || isViewMode || isUserSelected}
                    disabled
                  />
                </div>

                <div className="col-12 col-md-6 mb-4">
                  <label className="form-label">
                    Role <span className="asterisk danger">*</span>
                  </label>
                  <select className={`form-select ${errors.role ? "is-invalid" : ""}`} {...register("role", { required: true })}
                  disabled={isViewMode}>
                    <option value="">Select</option>
                    {
                      roleLst?.map((department) => (
                        <option key={department.id} value={department.id}>
                          {department.roleName}
                        </option>
                      ))
                    }
                  </select>
                </div>


                <div className="col-12 col-md-6 mb-3">
                  <label className="form-label" htmlFor="status">
                        Status <span className="asterisk danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    id="recordStatus"
                    disabled={isViewMode}
                    {...register("recordStatus", { required: "Status is required" })}
                  >
                    <option value="" disabled>
                      Select Status
                    </option>
                    {Object.entries(RecordStatusEnum)
                    .filter(([key, value]) => value !== "Deleted")
                    .map(([key, value]) => (
                      <option key={key} value={value}>
                        {value}
                      </option>
                    ))}
                  </select>
                  {errors.recordStatus && <p className="text-danger">{errors.recordStatus.message}</p>}
                </div>

                <div className="col-12 col-md-12 mb-4">
                  <label className="form-label">Notes</label>
                  <textarea
                    className="form-control h-100"
                    placeholder="Please enter the notes"
                    {...register("notes")}
                    readOnly={isViewMode}
                  ></textarea>
                </div>
                
                


              </div>
            </div>

            <div className="popup-footer position-absolute w-100 d-flex">
              <div className="ms-auto d-flex gap-2">
                <button type="button" className="btn btn-dark btn-lg" onClick={closePopup}>
                  Cancel
                </button>

                <button type="submit" className="btn btn-success btn-lg" hidden={isViewMode}>
                  {existingdata?"Update": "Add"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
